import { countryData } from "@/dashboard-api-types/models/countryData.types";
import { MAX_COUNTRIES_EXPORT } from "./limits";

export type CountryExportOption = {
  value: number;
  label: string;
  continent?: string | null;
  idfRegion?: string | null;
  incomeLabel?: string | null;
  whoRegion?: string | null;
};

const getForm = (countryOptions?: countryData[]) => ({
  formId: "export-form",
  formField: {
    countryExport: {
      name: "locCodes",
      label: "Country",
      options: [
        ...(Array.isArray(countryOptions) ? countryOptions : []).map(
          ({
            country_LocCode,
            country_LocName,
            country_Continent,
            country_IDFRegion,
            country_IncomeLabel,
            country_WHOregion,
          }): CountryExportOption => ({
            value: country_LocCode as number,
            label: country_LocName ?? "",
            continent: country_Continent ?? null,
            idfRegion: country_IDFRegion ?? null,
            incomeLabel: country_IncomeLabel ?? null,
            whoRegion: country_WHOregion ?? null,
          })
        ),
      ] as CountryExportOption[],
      errorMsg: "Required",
      errorMinMaxMsg: `Select between 1 and ${MAX_COUNTRIES_EXPORT} countries`,
    },
  },
});

export default getForm;
